import { INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT } from '../../constants/inlineLayout';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useAssetMembershipCondition } from '../../hooks/useAssetMembershipCondition';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import EditorAssetMembershipCondition from './EditorAssetMembershipCondition';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionAsset from './EditorConditionAsset';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import { Select } from 'foundations-components/transitional/components/Select';
import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorAssetMembershipConditionResponsive = ({
  condition,
  conditionPath,
  filterFamily,
  inputUse,
  isNested
}) => {
  const {
    width
  } = useElementSize();
  const {
    onFieldConditionFieldChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const {
    onConditionDelete,
    onSelectedOptionChange,
    operatorOptions
  } = useAssetMembershipCondition(filterFamily, condition, conditionPath);
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorAssetMembershipCondition, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      inputUse: inputUse,
      isNested: isNested
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    isNestedOrHeader: isNested,
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: filterFamily,
      hideChangeFieldButton: true,
      onConditionDelete: () => onConditionDelete(conditionPath),
      deleteButtonLayoutStyle: "inline",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: `${INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: filterFamily,
          inputUse: inputUse,
          onAssetChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: `${INPUT_WIDTHS_FOR_TWO_INPUTS_WITH_BULLET_POINT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(Select, {
          "data-selenium-test": "fr-filter-operator-select"
          //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
          ,
          disabled: condition.field && condition.field.userHasNoAccess,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(TypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          value: condition.constructor.toString(),
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
        })
      })]
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
};
export default EditorAssetMembershipConditionResponsive;